var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{class:_vm.$style.root,attrs:{"to":_vm.localePath(_vm.routes.home),"title":_vm.$t('Home Page')}},[_c('span',{class:_vm.$style.logo,style:(_vm.style)})])}
var staticRenderFns = []

export { render, staticRenderFns }